/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Partner_Faq_Short_QInputs */



/**
* | output |
* | --- |
* | "Why does a bill cover only a few days?" |
*
* @param {Partner_Faq_Short_QInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const partner_faq_short_q = /** @type {((inputs?: Partner_Faq_Short_QInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Partner_Faq_Short_QInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ ("Warum umfasst eine Abrechnung nur wenige Tage?")
	return /** @type {LocalizedString} */ ("Why does a bill cover only a few days?")
});